import {
  CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_BEGIN,
  CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_SUCCESS,
  CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_FAILURE,
  CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW } from '../../../common/config';

export function getBranchesByCarDealership(id) {
  return async (dispatch) => {
    dispatch({
      type: CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_BEGIN,
    });
    
    try {
      const res = await axios.get(REACT_APP_API_ABM_FW + "/abms/branch_office/Car_lot/" + id);
      const branches1 = res.data.data;
            if (branches1.length > 0) {
              dispatch({
                type: CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_SUCCESS,
                data: branches1,
              })
              return branches1
            } else {
              dispatch({
                type: CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_SUCCESS,
                data: []
              });
              return []
            }
    } catch(e) {
      dispatch({
        type: CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_FAILURE,
        data: { error: e },
      });
      return []
    }
  };
}

export function dismissGetBranchesByCarDealershipError() {
  return {
    type: CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_BEGIN:
      return {
        ...state,
        getBranchesByCarDealershipPending: true,
        getBranchesByCarDealershipError: null,
      };

    case CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_SUCCESS:
      return {
        ...state,
        getBranchesByCarDealershipPending: false,
        getBranchesByCarDealershipError: null,
        branchByCarDealershipList: [...action.data]
      };

    case CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_FAILURE:
      return {
        ...state,
        getBranchesByCarDealershipPending: false,
        getBranchesByCarDealershipError: action.data.error,
      };

    case CAR_DATA_MASTER_GET_BRANCHES_BY_CAR_DEALERSHIP_DISMISS_ERROR:
      return {
        ...state,
        getBranchesByCarDealershipError: null,
      };

    default:
      return state;
  }
}
